import { prefixString } from "../helpers/string";

export default function initSettingsStore(Alpine, { prefix }) {
  return {
    showTooltips: true,
  };
}
